class VariantButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.variantDrawers = document.querySelectorAll(".variants-drawer")
    this.overlay = document.querySelector(".variants-drawer-overlay")

    this.addEventListener("click", ()=>this.openDrawer())
    setTimeout(()=>{
      this.drawer = this.closest(".variant-button__wrapper")?.querySelector(".variants-drawer")
      this.closeButton = this.drawer.querySelector(".variants-drawer__close-button")
      if (this.closeButton){
        this.closeButton.addEventListener("click", ()=>this.closeDrawer())
      }

      if (this.overlay) {
        this.overlay.addEventListener("click", ()=>this.closeDrawer())
      }
    }, 0)
  }

  openDrawer(){
    this.variantDrawers.forEach(drawer => {
      drawer.classList.remove("open")
    })

    this.drawer.classList.add("open")
  }

  closeDrawer(){
    this.drawer.classList.remove("open")
  }
}

customElements.define("variant-button", VariantButton)